const UnitTypes = {
    HEADER: 'header',
    FOOTER: 'footer',
    SECTION_HEADER: 'sectionHeader',
    TEXT: 'text',
    PREVIEW: 'preview',
    AR_FILTER: 'ARFilter',
    OBJECT: 'object'
};

export const TextUnitStyle = {
    STRONG: 'strong',
    EMPHASIS: 'em',
    SHORT: 'short',
    DEFAULT: 'any-else'
};

export const TextShiftMode = {
    GLYPH: 'glyph',
    LINE: 'line'
};

export default UnitTypes;
